import { render, staticRenderFns } from "./blogRightSidebar.vue?vue&type=template&id=645b6c97&"
import script from "./blogRightSidebar.vue?vue&type=script&lang=js&"
export * from "./blogRightSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports